module.exports = "/fonts/fa-brands-400.woff2?3d19aa4959c59e6d93d44f3bd90aef14";